import { render } from "./CopyRight.vue?vue&type=template&id=e4c6fd06"
import script from "./CopyRight.vue?vue&type=script&lang=js"
export * from "./CopyRight.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__